import React, { useState } from "react";
import Icon from "./Icon";

export default function ContactModal({ data, onClose, onSent }) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    const to = data.links.find((l) => l.kind === "email")?.href.replace("mailto:", "") || "";
    const subject = encodeURIComponent(`Portfolio contact from ${name}`);
    const body = encodeURIComponent(`${message}\n\n- ${name} (${email})`);
    window.location.href = `mailto:${to}?subject=${subject}&body=${body}`;
    onSent();
  };

  return (
    <div className="scrim" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
          <div>
            <h3 className="modal-h">Get in touch</h3>
            <p className="modal-sub">A line about the role or what you're building.</p>
          </div>
          <button className="modal-x" onClick={onClose}><Icon name="x" size={18} /></button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="field">
            <label>Name</label>
            <input placeholder="Your name" required value={name} onChange={(e) => setName(e.target.value)} />
          </div>
          <div className="field">
            <label>Email</label>
            <input type="email" placeholder="your@email.com" required value={email} onChange={(e) => setEmail(e.target.value)} />
          </div>
          <div className="field">
            <label>Message</label>
            <textarea
              placeholder="A line about the role or project…"
              required
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            ></textarea>
          </div>
          <div className="modal-actions">
            <button type="button" className="btn btn-secondary" onClick={onClose}>Cancel</button>
            <button type="submit" className="btn btn-primary">
              <Icon name="send" size={15} /> Send
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
